import { Purchases } from '@revenuecat/purchases-js'
import { createContext } from 'react'

type PaymentSession = {
  revenueCat: Purchases
  token: string
}

export const paymentSessionContext = createContext<PaymentSession>({} as PaymentSession)

export enum ErrorType {
  PartnerMisconfiguration = 'PartnerMisconfiguration',
  InternalMisconfiguration = 'InternalMisconfiguration',
}
